import React, { Component } from 'react'
import { Form, FormGroup, ControlLabel } from 'react-bootstrap'
import { Radio } from 'react-icheck'
class EMRadio extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e)
    }

    render() {
        let {formData,schema,required,uiSchema} = this.props
        return(
            <Form>
                <FormGroup>
                    {uiSchema.title?
                    <ControlLabel>{schema.title}{required?<span className='text-red'>*</span>:''}</ControlLabel>
                    :''}
                    <div>
                        {uiSchema.options.length>0?
                        uiSchema.options.map((item,index)=>
                        <span key={index}>
                            <Radio
                                onChange={this.onFormChange.bind(this,item.value)}
                                checked={formData===item.value?true:false}
                                radioClass="iradio_square-blue"
                                increaseArea="20%"       
                                label={' '+item.label}           
                            />
                            &nbsp;
                        </span>
                        ):''}
                    </div>    
                </FormGroup>
            </Form>    
        )
    }    
}    
export default EMRadio


// WEBPACK FOOTER //
// ./src/view/hr/employee/EMRadio.js